export default "__VITE_ASSET__BqpaeQxc__"